import { Typography as TypographyBase } from "@mindlercare/ui-web";
import { useDemo } from "contexts/DemoContext";
import { ComponentProps, ReactNode } from "react";

type BaseProps = ComponentProps<typeof TypographyBase>;
type TypographyProps = Omit<BaseProps, "children"> & {
  children?: ReactNode;
};

export const Typography = (props: TypographyProps) => {
  const isDemo = useDemo();

  return <TypographyBase {...(props as BaseProps)} isDemo={isDemo} />;
};
